export default __webpack_public_path__ + "static/media/ScanIcon.0212303a.svg";